module.exports = __webpack_public_path__ + "static/media/ap.f1b8e70b.png";